module.exports = __webpack_public_path__ + "static/media/sub_com_house.e68f4ac4.jpg";